import { createSlice } from '@reduxjs/toolkit';

import { setTenantAccessToken } from '~tenant-modules/auth/store/tenant-auth-actions';

import { tenantSignOutThunk, tenantVerifyOtpThunk } from './tenant-auth-thunks';

type AuthStateType = {
  accessToken: string | null;
  isLoading: boolean;
};

const initialState: AuthStateType = {
  accessToken: '',
  isLoading: false,
};

export const tenantAuthSlice = createSlice({
  name: 'tenantAuth',
  initialState,
  reducers: {
    // setAccessToken: (store, action) => {
    //   console.log('setAccessToken::called');
    //   store.accessToken = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(setTenantAccessToken, (state, action) => {
      state.accessToken = action.payload;
    });

    builder.addCase(tenantVerifyOtpThunk.pending, (store) => {
      store.isLoading = true;
    });
    builder.addCase(tenantVerifyOtpThunk.fulfilled, (store, action) => {
      store.accessToken = action.payload?.access_token || '';
      store.isLoading = false;
    });
    builder.addCase(tenantVerifyOtpThunk.rejected, (store) => {
      store.isLoading = false;
    });

    // builder.addCase(tenantSignInThunk.pending, (store) => {
    //   store.isLoading = true;
    // });
    // builder.addCase(tenantSignInThunk.fulfilled, (store, action) => {
    //   store.accessToken = action.payload?.access_token || '';
    //   store.isLoading = false;
    // });
    // builder.addCase(tenantSignInThunk.rejected, (store) => {
    //   store.isLoading = false;
    // });

    builder.addCase(tenantSignOutThunk.pending, (store) => {
      store.isLoading = true;
    });
    builder.addCase(tenantSignOutThunk.fulfilled, (store) => {
      store.accessToken = null;
      store.isLoading = false;
    });
    builder.addCase(tenantSignOutThunk.rejected, (store) => {
      store.isLoading = false;
    });
  },
});

export default tenantAuthSlice.reducer;
